import React, { useEffect, useState } from "react";
import { Aboutsec1, Aboutsec2 } from "./components/Aboutcomponent";
import { Sec2, Sec3, Sec5 } from "./components/Homecomponent";
import PageHeader from "./components/PagesHeaderComponent/PageHeader";
import newsImg from "../assets/images/newsImg.png"
import educationImg from "../assets/images/education.png"
import notificationImg from "../assets/images/notification.png"
import { Button, Card } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom/dist";
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/pagination';
import { Tabs } from "antd";
import { FreeMode, Navigation, Thumbs } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import { faCalendar, faCalendarDays, faClock, faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import CoreHttpHandler from "../http/services/CoreHttpHandler";
import { Box, LinearProgress } from "@mui/material";


const NewsFeedsDetails = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const [news, setNews] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [activeKey, setActiveKey] = useState(1);

	const getNews = () => {
		setIsLoading(true)
		CoreHttpHandler.request(
			"library",
			activeKey == 1 ?
				"fetchGovNews" : "fetchCompNews",
			{},
			(res) => {
				setNews(res.data.data.news)
				setIsLoading(false)
			},
			(err) => {

			}
		);
	};


	const { description, title, image, dt } = location.state;
	const data = [
		{
			title: "Education Reform",
			img: educationImg,
			desc: "Major overhaul planned to  strengthen the public education system"
		},
		{
			title: "Environmental Regulations",
			img: educationImg,
			desc: "Government announces stricter measures to combat climate change"
		},
		{
			title: "Research",
			img: educationImg

		}

	]
	const items = [
		{
			key: '1',
			label: 'Governance News',
			children: (
				<Swiper
					spaceBetween={50}
					slidesPerView={1}
					navigation={true}
					style={{ padding: "50px" }}
					modules={[FreeMode, Navigation, Thumbs, Pagination]}
					// onSlideChange={() => console.log('slide change')}
					// onSwiper={(swiper) => console.log(swiper)}
					breakpoints={{
						// 0: {
						//   slidesPerView: 1,
						// },
						900: {
							slidesPerView: 2,
						},

					}}
				>
					<div className="relatedNewswrap">
						{isLoading ?
							<Box sx={{ my: '5rem' }}>
								<LinearProgress color="success" />
							</Box>
							:
							news.map((e, index) => (
								<SwiperSlide key={index}>
									<Card className="cards">
										<img alt="Education" variant="top" src={e.image} />
										<h4>{e.title}</h4>
										<div className="card-content">
											<h6>{e.description?.length > 90 ? e.description?.slice(0, 90) + "..." : e.description}</h6>
											<button className="rounded_btn" variant="primary">Read More</button>
										</div>
									</Card>
								</SwiperSlide>
							))
						}
					</div>
				</Swiper>
			),
		},
		{
			key: '2',
			label: 'Company Specific News',
			children: (
				<Swiper
					spaceBetween={50}
					slidesPerView={1}
					navigation={true}
					style={{ padding: "50px" }}
					modules={[FreeMode, Navigation, Thumbs, Pagination]}
					// onSlideChange={() => console.log('slide change')}
					// onSwiper={(swiper) => console.log(swiper)}
					breakpoints={{
						// 0: {
						//   slidesPerView: 1,
						// },
						900: {
							slidesPerView: 2,
						},

					}}
				>
					<div className="relatedNewswrap">
						{isLoading ?
							<Box sx={{ my: '5rem' }}>
								<LinearProgress color="success" />
							</Box>
							:
							news.map((e, index) => (
								<SwiperSlide key={index}>
									<Card className="cards">
										<img alt="Education" variant="top" src={e.image} />
										<h4>{e.title}</h4>
										<div className="card-content">
											<h6>{e.description?.length > 90 ? e.description?.slice(0, 90) + "..." : e.description}</h6>
											<button className="rounded_btn" variant="primary">Read More</button>
										</div>
									</Card>
								</SwiperSlide>
							))
						}
					</div>
				</Swiper>
			),
		},

	];

	const onChange = (key) => {
		setActiveKey(key);
	};

	useEffect(() => {
		getNews();
	}, [activeKey])
	return (
		<>
			<PageHeader heading={title} />
			<div className="content_wrap">

				<section className='newsDetails'>
					<div className='container'>

						{/* <div className="cards_wrap"> */}
						<img alt="Education" variant="top" src={image} />
						<div>

							<h6>
								<FontAwesomeIcon className="icon" fontSize={20} icon={faCalendarDays} />
								{moment(dt).format("DD-MM-YYYY")}
							</h6>
							{/* <h6>
							<FontAwesomeIcon className="icon" fontSize={20} icon={faClock} />
							3 min read
						</h6>
						<h6>
							<FontAwesomeIcon className="icon" fontSize={20} icon={faEye} />
							5817
						</h6> */}
						</div>
						<h6 className="desc"><td dangerouslySetInnerHTML={{__html: description}} /></h6>

					</div>
					{/* </div> */}
				</section>

				{/* {news.length > 2 &&
					<section className='sec sec5'>
						<div className='container'>
							<div className="flex_btw">

								<h1 className="bold">Related News</h1>
							</div>

							<div>
								<Tabs defaultActiveKey="1" items={items} onChange={onChange} />
							</div>
						</div>
					</section>
				} */}
			</div>

		</>
	);
};

export default NewsFeedsDetails;
